import { render } from "./grupoestatus.vue?vue&type=template&id=0f0c4fa5&scoped=true"
import script from "./grupoestatus.vue?vue&type=script&lang=js"
export * from "./grupoestatus.vue?vue&type=script&lang=js"

import "./grupoestatus.vue?vue&type=style&index=0&id=0f0c4fa5&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0c4fa5"]])

export default __exports__